import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnInit, OnChanges {

  constructor() { }

  @Input() items: any[] = [];
  @Input() displayProperty: string = "";
  @Input() valueProperty: string = "";
  @Input() nestProperty: string | undefined = "";
  @Input() model: any | null | undefined = "";
  @Input() inlineLabel?: string;
  @Input() readonly?: boolean = false;
  @Input() noSelectionText?: string = '';
  @Output() modelChange = new EventEmitter<any>();
  @Output() onChange = new EventEmitter<string>();

  selectedItem: any = null;

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['model'] == null) {
      return;
    }

    this.selectedItem = this.items.find(c => c[this.valueProperty] == changes['model'].currentValue);

    if (this.selectedItem == null) {
      if (this.model != null && this.model != "") {
        this.modelChange.emit('');
      }
    }
  }

  itemSelected(item: any) {
    if (this.selectedItem == item) {
      return;
    }
    this.selectedItem = item;
    this.modelChange.emit(this.selectedItem[this.valueProperty]);
    this.onChange.emit(this.selectedItem[this.valueProperty]);
  }

}
